<div class="date-input" (keydown)="key($event)">
  <div class="input-group">
    <input type="text" [name]="inputName" [value]="value" (input)="input($event)"
           (click)="openCalendar()" [disabled]="disabled" class="form-control"
           placeholder="yyyy-MM-dd" aria-label="実施日" [attr.aria-invalid]="invalid"
           [attr.aria-expanded]="expanded" aria-haspopup="dialog" autocomplete="off">
    <div class="input-group-append">
      <button type="button" class="btn btn-outline-secondary" aria-label="カレンダーを開く"
              [disabled]="disabled" (click)="openCalendar(true)"><i class="fa fa-calendar" aria-hidden="true"></i></button>
    </div>
  </div>
  @if (invalid) { <small class="text-danger" role="alert">実施日は yyyy-MM-dd 形式の正しい日付を入力してください。</small> }
  @if (expanded) {
    <div class="calendar" role="dialog" aria-label="実施日カレンダー">
      <div class="calendar-heading">
        <button type="button" class="btn btn-sm btn-light" aria-label="前月" (click)="moveMonth(-1)">‹</button>
        <strong aria-live="polite">{{ year }}年 {{ month + 1 }}月</strong>
        <button type="button" class="btn btn-sm btn-light" aria-label="翌月" (click)="moveMonth(1)">›</button>
      </div>
      <div class="days">
        @for (weekday of weekdays; track weekday) { <span class="weekday">{{ weekday }}</span> }
        @for (day of days; track $index) {
          @if (day) {
            <button type="button" class="day" [class.selected]="day.value === value"
                    [attr.aria-label]="day.value" [attr.aria-pressed]="day.value === value"
                    [attr.data-date]="day.value" (focus)="focusedDay = day.value" (click)="choose(day.value)">{{ day.day }}</button>
          } @else { <span></span> }
        }
      </div>
      <div class="calendar-footer">
        <button type="button" class="btn btn-sm btn-light" (click)="clear()">クリア</button>
        <button type="button" class="btn btn-sm btn-light" (click)="expanded = false">閉じる</button>
      </div>
    </div>
  }
</div>
